import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';

import CustomHeader from './custom-header';
import TimeColumn from './time-column';

import './custom-events-wrapper.less';
import './custom-sizes.less';

const CustomEventWrapper = (props) => {
  const {
    loading,
    rootContainer,
    headEvents,
    onEditEvent,
    onAddEvent,
    onDeleteEvent,
    timeSteps,
    days,
    calendarCategories,
    settings,
    onToggleEvents,
  } = props;

  return (
    <Spin spinning={loading} style={{ maxHeight: 'unset' }}>
      <div className="calendar-custom-mode-view">
        <CustomHeader
          rootContainer={rootContainer}
          headEvents={headEvents}
          onEditEvent={onEditEvent}
          onAddEvent={onAddEvent}
          onDeleteEvent={onDeleteEvent}
          days={days}
          calendarCategories={calendarCategories}
          settings={settings}
          onToggleEvents={onToggleEvents}
        />

        <div className="calendar-custom-mode-main">
          <div className="calendar-custom-mode-content">
            <TimeColumn timeSteps={timeSteps} />

            <div className={'custom-mode-events right-pane'}>{props.children}</div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default CustomEventWrapper;
